import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_NOTIFICATION_LISTING,
    ADD_NOTIFICATION,
    UPDATE_NOTIFICATION,
    DELETE_NOTIFICATION,
    EXPORT_NOTIFICATION,
    GET_NOTIFICATION_DETAILS,
    READ_NOTIFICATION,
    READ_ALL_NOTIFICATION,
} from "./actionTypes.js";

import {
    getNotificationListingSuccess,
    getNotificationListingFail,
    getNotificationDetailsSuccess,
    createNotificationSuccess,
    createNotificationFail,
    updateNotificationSuccess,
    updateNotificationFail,
    deleteNotificationSuccess,
    deleteNotificationFail,
    exportNotificationSuccess,
    exportNotificationFail,
    getNotificationDetailsFail,
    getReadNotificationSuccess,
    getReadNotificationFail,
    getReadAllNotificationSuccess,
    getReadAllNotificationFail,
} from "./actions.js";

import {
    notificationListingApi,
    notificationDetailsApi,
    addNotificationApi,
    updateNotificationApi,
    deleteNotificationApi,
    exportNotificationApi,
    readNotificationApi,
    bulkReadNotificationApi,
} from "./notificationApi.js";

function* fetchNotificationListing({ payload }) {
    try {
        const response = yield call(notificationListingApi, payload);
        yield put(getNotificationListingSuccess(response));
    } catch (error) {
        yield put(getNotificationListingFail(error));
    }
}

function* fetchNotificationDetail({ payload }) {
    try {
        const response = yield call(notificationDetailsApi, payload);
        yield put(getNotificationDetailsSuccess(response));
    } catch (error) {
        yield put(getNotificationDetailsFail(error));
    }
}

function* createNotification({ payload }) {
    try {
        const response = yield call(addNotificationApi, payload);
        yield put(createNotificationSuccess(response));
    } catch (error) {
        yield put(createNotificationFail(error));
    }
}

function* updateNotification({ payload }) {
    try {
        const response = yield call(updateNotificationApi, payload);
        yield put(updateNotificationSuccess(response));
    } catch (error) {
        yield put(updateNotificationFail(error));
    }
}

function* deleteNotification({ payload }) {
    try {
        const response = yield call(deleteNotificationApi, payload);
        yield put(deleteNotificationSuccess(response));
    } catch (error) {
        yield put(deleteNotificationFail(error));
    }
}

function* exportNotification({ payload }) {
    try {
        const response = yield call(exportNotificationApi, payload);
        yield put(exportNotificationSuccess(response));
    } catch (error) {
        yield put(exportNotificationFail(error));
    }
}

function* readNotification({ payload }){
    try{
        const response = yield call(readNotificationApi, payload);
        yield put(getReadNotificationSuccess(response));
    } catch (error) {
        yield put(getReadNotificationFail(error))
    }
}

function* readAllNotification({ payload }){
    try{
        const response = yield call(bulkReadNotificationApi, payload);
        yield put(getReadAllNotificationSuccess(response));
    } catch (error) {
        yield put(getReadAllNotificationFail(error))
    }
}

function* NotificationSaga() {
    yield takeEvery(GET_NOTIFICATION_LISTING, fetchNotificationListing);
    yield takeEvery(GET_NOTIFICATION_DETAILS, fetchNotificationDetail);
    yield takeEvery(ADD_NOTIFICATION, createNotification);
    yield takeEvery(UPDATE_NOTIFICATION, updateNotification);
    yield takeEvery(DELETE_NOTIFICATION, deleteNotification);
    yield takeEvery(EXPORT_NOTIFICATION, exportNotification);
    yield takeEvery(READ_NOTIFICATION, readNotification);
    yield takeEvery(READ_ALL_NOTIFICATION, readAllNotification);
}

export default NotificationSaga
